export default __webpack_public_path__ + "static/media/industry1.fe97cf50.png";